import React from 'react'
import { useTranslation } from 'react-i18next'
import { InsightViewOptionStrings } from 'enums/InsightViewOption'
import messageUtil from 'utils/messageUtil'

const Title = ({
  viewOption,
  isForAllTopics
}: {
  viewOption: InsightViewOptionStrings
  isForAllTopics: boolean
}) => {
  const { t } = useTranslation()

  const title = isForAllTopics
    ? t('averageMetricForAllTopics', { metric: messageUtil.viewOption(viewOption) })
    : t('averageMetric', { metric: messageUtil.viewOption(viewOption) })

  return <div>{title}</div>
}

export default Title
